// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    name: {
        title: '客户姓名',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入客户姓名'
        }]
    },
    contact: {
        title: '联系人',
        type: 'input',
        aliasType: 'text',
        value: ''
    },
    mobile: {
        title: '手机号',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入手机号'
        }]
    },
    card_type: {
        title: '证件类型',
        type: 'select',
        items: [{
            id: 1,
            name: '身份证'
        }],
        value: 1
    },
    sfz: {
        title: '证件号码',
        type: 'input',
        aliasType: 'text',
        value: ''
    },
    address: {
        title: '地址',
        type: 'input',
        aliasType: 'text',
        value: ''
    },
    arae_id: {
        title: '区域',
        type: 'select',
        items: [],
        value: ''
    },
    shop: {
        title: '门店',
        type: 'input',
        aliasType: 'text',
        value: ''
    },
    ctyid: {
        title: '客户类型',
        type: 'select',
        items: [],
        value: '',
        rules: [{
            required: true,
            message: '请选择客户类型'
        }]
    },
    attribute: {
        title: '属性',
        type: 'input',
        value: ''
    },
    type: {
        title: '是否常用',
        type: 'select',
        value: '',
        items: [{
            id: 1,
            name: '是'
        }, {
            id: 2,
            name: '否'
        }],
        rules: [{
            required: true,
            message: '请选择是否常用'
        }]
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '客户姓名',
    dataIndex: 'name',
    filterIndex: 'name',
    key: 'name',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '联系人',
    dataIndex: 'contact',
    filterIndex: 'contact',
    key: 'contact',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '手机号码',
    dataIndex: 'mobile',
    filterIndex: 'mobile',
    key: 'mobile',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '客户地址',
    dataIndex: 'address',
    key: 'address',
    ...columnPublicConfig
},
{
    title: '所属区域',
    dataIndex: 'areaname',
    key: 'areaname',
    width: 115,
    ...columnPublicConfig
},
// {
//     title: '所属气站',
//     dataIndex: 'status',
//     key: 'status',
//     ...columnPublicConfig
// },
{
    title: '所属门店',
    dataIndex: 'shop',
    key: 'shop',
    ...columnPublicConfig
},
{
    title: '客户类型',
    dataIndex: 'typename',
    filterIndex: 'ctyid',
    key: 'typename',
    type: 'select',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '是否常用',
    dataIndex: 'type',
    filterIndex: 'type',
    key: 'type',
    type: 'select',
    items: [{
        id: 1,
        name: '是'
    }, {
        id: 2,
        name: '否'
    }],
    scopedSlots: {
        customRender: 'c-type',
        ...filterItemsConfig.scopedSlots
    },
    ...columnPublicConfig
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 180,
    scopedSlots: {
        customRender: 'c-action'
    }
}]
